module.exports = __webpack_public_path__ + "static/media/arrow-down-black.e14e1131.svg";